import { render } from "./MyApplicationsView.vue?vue&type=template&id=35c6e3a0"
import script from "./MyApplicationsView.vue?vue&type=script&lang=js"
export * from "./MyApplicationsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__